import { memo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEventCategory, trackApiCall, trackButtonClick } from "@/utils/analytics";
import { getSrpLocationLabel } from "@/utils/filterTrackingService";
import { checkLoginStatus } from "@/api/myProfile";
import { isPhoneNoVerified } from "@/api/bid";
import { getBidCenterDetails, getPDPInitData } from "@/api/PDP";
import { enableOwnItNow, fetchPDPBidCenterDataSuccess, fetchPDPInitialLoadSuccess, fetchPDPLatestBidCenterData, setOfferData, setSelectedBidAmount } from "@/redux/PDP/pdpSlice";
import { setListingId } from "@/bidFeature/propertyDetailSlice";
import { useNavigate } from "react-router";
import { getLatestLisiting } from "@/api/savedPreference";
import { navigateToProperty } from "@/utils/propertyNavigation";

const BidButton = ({item, title, isRecommendedProperties, cardIndex, style}) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const userId = useSelector((state) => state?.user?.user?.realbidUserId);

  const onPlaceBid = async () => {
    try {
      setLoading(true);
      let eventCategory = getEventCategory();
      trackButtonClick({
        eventName: "user_type_check",
        eventCategory: eventCategory,
        eventSource: "Place bid click",
      });
      const loginResponse = await checkLoginStatus();
      if (loginResponse) {
        await isPhoneNoVerified(
          loginResponse.primaryPhone
        );
        trackApiCall({
          eventName: "user_type_check_success",
          eventCategory: eventCategory,
          eventSource: "Place bid click api call",
        });

        const data = await getBidCenterDetails(item?.listingId);
        const details = await getPDPInitData(item?.listingId);

        trackButtonClick({
          eventName: "place_bid_click",
          eventCategory: eventCategory,
          eventSource: "Place bid click",
          eventLabel: `listingId: ${item?.listingId} | Source: SRP`,
          eventParams: { source: "srp" },
        });

        dispatch(fetchPDPBidCenterDataSuccess(data));
        dispatch(fetchPDPLatestBidCenterData(item?.listingId));
        dispatch(fetchPDPInitialLoadSuccess(details));
        dispatch(setListingId(item?.listingId));
        dispatch(setSelectedBidAmount(null));
        dispatch(enableOwnItNow(false));
        setLoading(false);
        navigate("/bid");
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

    const onPlaceOffer = async ({title}) => {
      try {
        setLoading(true);
        const data = await getLatestLisiting({ propertyId: item?.propertyId });
        const state = {
          listingId: item?.listingId,
          userId: userId,
          offerAmount: data?.minimumOfferAmount,
          offerType: title === "Place Offer" ? "PLACE_OFFER" : "PLACE_BACKUP_OFFER",
        };
        setLoading(false);
        dispatch(setOfferData(state))
        navigate("/offer", { state: state });

      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    };
  const onViewDetails = ({title: label}) => {
    setLoading(true);
    const eventCategory = getEventCategory();

    trackButtonClick({
      eventName:
        eventCategory === "NEW-SRP"
          ? `property_card_click`
          : `recommended_property_click`,
      eventCategory: eventCategory,
      eventSource:
        eventCategory === "NEW-SRP"
          ? `${label ? label : "Property card"} click`
          : `Recomended property detials click`,
      eventLabel:
        eventCategory === "NEW-SRP"
          ? `Property id: ${item?.propertyId}| Location: ${getSrpLocationLabel()}`
          : `Section position: 5 | Property position: ${
              cardIndex + 1
            } | Property id: ${item?.propertyId}`,
      eventParams: { section: label ? label : "property" },
    });

    setLoading(false);
    navigateToProperty(item?.listingUrl || `/property/${item?.listingId || item?.propertyId}`, item?.category, item?.propertyStatus);
  };
  const isRedButton = isRecommendedProperties || title === 'Place Bid' || title === 'Place Backup Bid' || title === 'Place Offer' || title === 'Place Backup Offer';
  return (
    <button
      type="button"
      id={ `${title?.replace(/\s/g, '')}-${cardIndex}`}
      className={`btn booking_btn float-end ${isRedButton ? 'card-btn-thm2' : 'card-btn-thm'}`}
      style={{fontSize: 12, ...style}}
      onClick={() => {
        switch (title) {
          case 'View Details':
            onViewDetails({title});
            break;
          case 'Place Bid':
            onPlaceBid();
            break;
          case 'Place Backup Bid':
            onPlaceBid();
            break;
          case 'Place Offer':
            onPlaceOffer({title});
            break;
          case 'Place Backup Offer':
            onPlaceOffer({title});
            break;

          default:
            break;
        }
      }}
    >
      {loading? 'Processing...' : title}
    </button>
  );
};
export default memo(BidButton);